// The invite link token (stored as 'BreefAccesstoken' when the participant opens their link) authenticates
// the participant's own game calls: report, score, status, breef and settings.
export const breefLinkHeaders = () => {
  const token = sessionStorage.getItem('BreefAccesstoken');
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
